// extracted by mini-css-extract-plugin
module.exports = {"button":"AppointmentSlotTaken-module__button___Q5jsp","message":"AppointmentSlotTaken-module__message___W7-RY"};